module.exports = __webpack_public_path__ + "assets/img/ic-smoke.1b60f448.svg";